import { render, staticRenderFns } from "./activity-detail.vue?vue&type=template&id=14e3564c&scoped=true&"
import script from "./activity-detail.vue?vue&type=script&lang=js&"
export * from "./activity-detail.vue?vue&type=script&lang=js&"
import style0 from "./activity-detail.vue?vue&type=style&index=0&id=14e3564c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e3564c",
  null
  
)

export default component.exports